import React, { useState, useEffect } from 'react';
import './CountryFlag.css';

const CountrySelector = () => {
  const [countryData, setCountryData] = useState({
    code: 'in', // Default to India
    name: 'India',
    loading: true
  });

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        
        if (data && data.country_code) {
          setCountryData({
            code: data.country_code.toLowerCase(),
            name: data.country_name || 'Unknown',
            loading: false
          });
        } else {
          // If API doesn't return expected data, use default
          setCountryData({
            code: 'in',
            name: 'India',
            loading: false
          });
        }
      } catch (error) {
        console.error('Error fetching country:', error);
        // Use default values if API fails
        setCountryData({
          code: 'in',
          name: 'India',
          loading: false
        });
      }
    };

    fetchCountry();
  }, []);

  // Show hardcoded flag during loading to avoid empty space
  if (countryData.loading) {
    return (
      <div className="country-selector">
        <div className="country-flag">
          <div className="india-flag"></div>
        </div>
        <span className="country-name">IND</span>
      </div>
    );
  }
  
  // We always have a default country code (in), so this is just a safety check
  if (!countryData.code) {
    countryData.code = 'in';
    countryData.name = 'India';
  }

  // Use country code abbreviation
  const displayName = countryData.code.toUpperCase();

  return (
    <div className="country-selector" title={`Viewing from ${countryData.name}`}>
      <div className="country-flag">
        {/* Add a fallback div that will be visible if the image fails to load */}
        <div className="india-flag" style={{ display: 'none' }}></div>
        <img
          src={`https://flagcdn.com/24x18/${countryData.code}.png`}
          srcSet={`https://flagcdn.com/48x36/${countryData.code}.png 2x`}
          width="24"
          height="18"
          alt={`${countryData.name} flag`}
          onError={(e) => {
            // If flag image fails to load, show India flag
            e.target.style.display = 'none';
            e.target.previousSibling.style.display = 'block';
          }}
        />
      </div>
      <span className="country-name">{displayName}</span>
    </div>
  );
};

export default CountrySelector;